// extracted by mini-css-extract-plugin
export default {"searchForm":"ProductSearch_searchForm__dQGsZ","searchInput":"ProductSearch_searchInput__XUON9","searchButton":"ProductSearch_searchButton__T+dPq"};